import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  status: {
    fontSize: 12,
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
  },
  status_opacity: {
    fontSize: 12,
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    opacity: 0.5,
  },
  icon: {
    fontSize: 14,
    marginRight: 3,
  },
  marcadorDeTroca: {
    fontSize: 14,
    lineHeight: 1,
    marginRight: 3,
  },
}));
